<div class="property-services-tab">
    <div>
        <h3>Management services</h3>

        <ul>
            <li *ngFor="let key of managementServicesKeys" [hidden]="key == 'vendors_directory'">
                <switch-field [title]="managementServices[key]"
                              [value]="selectedItems[key]"
                              [disabled]="!canEdit || (key == 'bldn' && !propertyService.userIsSuperAdmin())"
                              (change)="update(key)">
                </switch-field>
            </li>
        </ul>
    </div>

    <hr>

    <div>
        <h3>Security services</h3>

        <ul>
            <li *ngFor="let key of securityServicesKeys">
                <switch-field [title]="securityServices[key]"
                              [value]="selectedItems[key]"
                              [disabled]="!canEdit"
                              (change)="update(key)">
                </switch-field>
            </li>
        </ul>
    </div>

    <hr>

    <div *ngIf="propertyService.account.isUserAdmin()">
        <h3>Resident services</h3>

        <ul>
            <li *ngFor="let key of residentServicesKeys">
                <switch-field
                        [title]="residentServices[key]"
                        [value]="selectedItems[key]"
                        [disabled]="!canEdit"
                        (change)="update(key)"></switch-field>
            </li>
        </ul>

        <div *ngIf="notificationBuildingSettings">
            <h3>Notification Service</h3>
            <ul>
                <li>
                    <switch-field
                        [title]="'Add Banners To Outgoing Emails'"
                        [value]="notificationBuildingSettings.allowBanner"
                        (change)="updateNotificationSettings({allowBanner: !notificationBuildingSettings.allowBanner})"></switch-field>
                </li>
            </ul>
        </div>
    </div>


    <spinner [spinnerShow]="propertyService.isServiceLoading"></spinner>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/services-view/services-view.component.html